import { render } from "./DepositPending.vue?vue&type=template&id=4624a0c5&scoped=true&ts=true"
import script from "./DepositPending.vue?vue&type=script&lang=ts"
export * from "./DepositPending.vue?vue&type=script&lang=ts"

import "./DepositPending.vue?vue&type=style&index=0&id=4624a0c5&lang=css&scoped=true"

import exportComponent from "/app/higgs.cps.portal.website/node_modules/.pnpm/vue-loader@16.8.3_f65c6e1beb608835961423903ad857fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4624a0c5"]])

export default __exports__